import { useLocation } from "@gatsbyjs/reach-router";
import AptusContext from "@whitespace/gatsby-plugin-smorgasbord-aptus-booking/src/contexts/aptusContext";
import { apartmentContext } from "@whitespace/gatsby-plugin-smorgasbord-fastapi";
import PropTypes from "prop-types";
import React, { useState, useContext } from "react";

import Modal from "../components/Modal.js";

export default function useModal() {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const { bookedPass, setBookedPass, setBookings, getCustomerBookings } =
    useContext(AptusContext);
  const { selectedApartment } = useContext(apartmentContext);

  const showModal = () => setIsVisible(true);
  const hideModal = () => {
    if (location.pathname === "/tvattider/" && bookedPass) {
      setBookings([]);
      setBookedPass(null);
      getCustomerBookings({ apartmentId: selectedApartment?.id });
    }
    setIsVisible(false);
  };

  RenderModal.propTypes = {
    children: PropTypes.node,
  };

  function RenderModal({ children }) {
    return <>{isVisible && <Modal closeModal={hideModal}>{children}</Modal>}</>;
  }

  return {
    showModal,
    hideModal,
    Modal: RenderModal,
  };
}
